module.exports = __webpack_public_path__ + "img/intro_1.07ae90b3.jpg";